/** Maps dirty form control paths to settings JSON keys included in FCDC patch. */
const CONTROL_PREFIX_TO_SETTING_KEYS: ReadonlyArray<
  readonly [prefix: string, ...settingKeys: string[]]
> = [
  ['acceptedCurrencies', 'acceptedCurrencies'],
  ['defaultCurrency', 'defaultCurrency'],
  ['vat', 'vat'],
  ['termsAndConditionsUrl', 'termsAndConditionsUrl'],
  ['privacyPolicyUrl', 'privacyPolicyUrl'],
  ['visualProfile', 'visualProfile'],
  ['sessionAllowedSignInMethods', 'sessionAllowedSignInMethods'],
  ['sessionMaxLength', 'sessionMaxLength'],
  ['sessionFreePaymentThreshold', 'sessionFreePaymentThreshold'],
  ['gracePeriod', 'gracePeriod'],
  ['refundGracePeriod', 'refundGracePeriod'],
  ['expiryReminder', 'expiryReminder'],
  ['durationUntilExpiry', 'expiryReminder'],
  [
    'bookingRates',
    'lockerBaseRates',
    'sessionLengthPriceCap',
    'sessionOverdueLengthPriceCap',
  ],
  ['lockerBaseRates', 'lockerBaseRates'],
  ['sessionLengthPriceCap', 'sessionLengthPriceCap'],
  ['sessionOverdueLengthPriceCap', 'sessionOverdueLengthPriceCap'],
  ['unlockPrice', 'unlockPrices'],
  ['serviceFee', 'serviceFee'],
  ['depositionPrice', 'depositionPrice'],
  ['availableHours', 'availableHours'],
  ['startTime', 'availableHours'],
  ['supportedPaymentMethods', 'supportedPaymentMethods'],
  ['customerMerchantAccount', 'supportedPaymentMethods'],
  ['customerClientKey', 'supportedPaymentMethods'],
  ['lockerBookingAllowed', 'lockerBookingAllowed'],
  ['lockerBookingLeadTime', 'lockerBookingLeadTime'],
  ['sessionPriceAlgorithm', 'sessionPriceAlgorithm'],
  ['sessionPriceSlots', 'sessionPriceSlots'],
  ['sessionSharedAccess', 'sessionSharedAccess'],
  ['sharedAccess', 'sessionSharedAccess'],
  ['unusedTimeRefundEnabled', 'unusedTimeRefund'],
  ['unusedTimeRefundSlotRefundMode', 'unusedTimeRefund'],
  ['unusedTimeRefundNotOverridable', 'unusedTimeRefund'],
]

function controlPathMatchesPrefix(path: string, prefix: string): boolean {
  return (
    path === prefix ||
    path.startsWith(`${prefix}.`) ||
    (path.startsWith(prefix) && path.length > prefix.length)
  )
}

export function settingKeysForDirtyControlPaths(
  names: readonly string[]
): Set<string> {
  const keys = new Set<string>()
  for (const name of names) {
    for (const [prefix, ...settingKeys] of CONTROL_PREFIX_TO_SETTING_KEYS) {
      if (controlPathMatchesPrefix(name, prefix)) {
        for (const key of settingKeys) {
          keys.add(key)
        }
      }
    }
  }
  return keys
}
